
import * as React from 'react'
import {CSSProperties} from 'react';
import {MajorAccountsHdr} from '../Components/MajorAccountsHdr';
import * as Tgcc from '../tgccGlobal';
import {MajorAccountsFooter} from '../Components/MajorAccountsFooter';
import Radium, { StyleRoot } from 'radium';
import * as Request from '../tgccRequest';
import {Message} from '../Components/Message';
import {browserHistory} from 'react-router';

const feedbackDiv: CSSProperties = {
    display:'flex',
    flexDirection:'column',
    margin:'10% auto',    
}

const btn : CSSProperties = {
    border: "1px solid transparent",
    backgroundColor: "rgb(226, 117, 88)",
    height: '40px',
    lineHeight: '40px',
    fontSize: '15px',
    padding: '0px 20px',
    textAlign: 'center',
    textTransform: 'uppercase',
    color: 'white',
    alignSelf: 'center',
    cursor: 'pointer',
    margin: '10px auto',
    width: '225px',
    fontFamily: 'Reitam'
}
const label: CSSProperties = {
    fontFamily:"AveriaSerifRegular",
    flexGrow:1,
    textAlign:'left'
}
const hdr: CSSProperties = {
    textAlign: 'center',
    fontFamily: 'AveriaSerifLightItalic',
    color: 'black',
    fontSize:'15px'
}

const style: CSSProperties = {
    border:'1px solid rgb(166, 166, 166)',
    fontFamily:"AveriaSerifRegular",
    width:'70%',
    backgroundColor:'#F6F3EE'

}
const errStyle: CSSProperties = {
    color:'red',
    textAlign:'center',
    fontSize:'15px'
}
const formDiv: React.CSSProperties = {
    backgroundColor:'white',
    width:'480px',
    padding:'20px',
    height:'365px',
    margin:'auto'
}


const inputDiv: React.CSSProperties = {
    display:'flex',
    flexDirection:'row',
    justifyContent: 'space-around',
    alignItems:'left',
    marginBottom:'10px'
}
const h1: React.CSSProperties = {
    fontFamily:"Reitam",
    textAlign:'center'
}

const p: React.CSSProperties = {
    textAlign:'center',
    fontSize:'18px',
    marginBottom:'20px',
    paddingLeft:'10px',
    paddingRight:'10px'
}
const p1 = Object.assign({},p,{marginBottom:'unset',margin:'auto',width:'50%'})
const points = Object.assign({},h1,{fontSize:'28px',marginBottom:'5px'});
const findout = Object.assign({},h1,{fontSize:'28px'});
const generate = Object.assign({},h1,{letterSpacing:'2px',fontSize:'28px',width:'85%',margin:'35px auto 0px'})

const imgStyle: React.CSSProperties = {
    backgroundImage: 'url('+ Tgcc.ResolveUrl('~/images/k12Landing.jpg')+')',
    backgroundPosition:'center',
    backgroundRepeat:'no-repeat',
    backgroundSize:'cover',
    width:'100%',
    height:'450px',
}
const hr: React.CSSProperties = {
    width:'930px',
    backgroundColor:'black',
    margin:'40px auto 20px',
    height:'1px',

}
const smallHr: React.CSSProperties = {
    height:'1px',
    margin:'auto',
    backgroundColor:'black',
    width:'75%'
}
const help: React.CSSProperties = {
    textAlign:'center',
    fontFamily:'Reitam',
    margin:'30px auto'
}
const contactInfo = Object.assign({},help,{})
const contactdiv: React.CSSProperties = {
    display:'flex',
    justifyContent: 'space-around',
    width:'982px',
    margin:'auto',
    textAlign:'center'
}
const contactInfoDiv: React.CSSProperties = {
    backgroundColor:'white',
    width:'480px',
    height:'225px'
}
const contactTxt: React.CSSProperties = {
    fontFamily:'AveriaSerifLightItalic'
}
const callDiv: React.CSSProperties = {
    marginTop:'9%'
}
const topHr: React.CSSProperties = {
    display:'flex',
    justifyContent:'center',
    marginBottom:'10px'
}
const est: React.CSSProperties = {
    fontFamily:'AveriaSerifLightItalic'
}
const bullets: React.CSSProperties = {
    display:'flex',
    justifyContent:'center',
    fontFamily:'Reitam',
    fontSize:'20px'
}
const bullets1 = Object.assign({},bullets,{marginBottom:'15px'})
const items: React.CSSProperties = {
    marginLeft:'25px'
}
const process:React.CSSProperties = {
    display:'flex',
    justifyContent:'center',
    marginTop:'20px'
}
const divs: React.CSSProperties = {
    backgroundColor:'white',
    textAlign:'center',
    width:'475px',
    marginRight:'15px'
}
const divs1 = Object.assign({},divs,{marginLeft:'15px',marginRight:'unset'})
const hdr1: React.CSSProperties = {
    fontFamily:'Reitam',
    color:'#E96656'
}
const hdr12 = Object.assign({},hdr1,{paddingTop:'15px'})
const hr1: React.CSSProperties = {
    width:'375px',
    height:'1px',
    backgroundColor:'black'
}
const hr13 = Object.assign({},hr1,{marginTop:'8px',marginBottom:'10px'})
const creative: React.CSSProperties = {
    paddingLeft:'15px',
    paddingRight:'15px'
}
const creative1 = Object.assign({},creative,{fontFamily:'AveriaSerifLightItalic'})
const h21: React.CSSProperties = {
    fontFamily:'Reitam',
    fontSize:'26px'
}
const payment: React.CSSProperties = {
    marginTop:'-15px',
    paddingBottom:'15px'
}
const fund: React.CSSProperties = {
    textAlign:'center',
    width:'982px',
    margin:'auto',
    backgroundColor:'white',
    height:'165px'
}
const fundTxt: React.CSSProperties = {
    width:'75%',
    margin:'auto'
}
const btnDiv: React.CSSProperties = {
    display:'flex'
}
const btmDiv: React.CSSProperties = {
    backgroundColor:'white',
    width:'982px',
    textAlign:'center',
    margin:'auto',
    height:'175px'
}
const easyImg: React.CSSProperties = {
    marginTop:'20px'
}
const k12Group: React.CSSProperties = {
    fontFamily:"Reitam",
    fontSize:'20px',
    textAlign:'center'
}
const k12Group1 = Object.assign({},k12Group,{marginTop:'15px'})
class _K12Landing extends React.Component<Tgcc.BaseProps,any> {
    state = {
        name:null,
        email:null,
        message:null,
        finished:false,
        error:'',
        isWaiting: false,
        help: false,
        contactName: null,
        phone:null
    }
    handleNameChange = (evt: React.FormEvent<HTMLInputElement>) =>{
        this.setState({name:evt.currentTarget.value});
    }
    handleContactNameChange = (evt: React.FormEvent<HTMLInputElement>) =>{
        this.setState({contactName:evt.currentTarget.value});
    }
    handleEmailChange = (evt:React.FormEvent<HTMLInputElement>) => {
        this.setState({email:evt.currentTarget.value});
    }

    handlePhoneChange = (evt:React.FormEvent<HTMLInputElement>) => {
        this.setState({phone:evt.currentTarget.value});
    }
    sendMessage = () => {       
        if(!this.state.name){
            this.setState({error:"Please provide your business name."})
        } else if(!this.state.email){
            this.setState({error:"Please provide your email address."})
        }else if(!this.state.contactName){
            this.setState({error:"Please provide your name."})
        }else if(!this.state.phone){
                this.setState({error:"Please provide your phone number"})
        }else {
            this.setState({isWaiting:true});
            var contactUs = new Tgcc.ContactUs;
            contactUs.name = this.state.name;
            contactUs.email = this.state.email;
            contactUs.contactName = this.state.contactName;
            contactUs.phone = this.state.phone;
            contactUs.timestamp = new Date().toLocaleString();
            Request.sendContactUS(contactUs,this.finished)
        }
    }
    finished = () => {
        this.setState({finished:true});
    }
    whenFinished = () => {
        browserHistory.push(Tgcc.Routes.Home);
    }
    getThankYou = () => {
        return <Message 
            Title="We will be in touch!"         
            UseTitleScript={true}
            Message1="Thanks for reaching out!"
            onContinue={this.whenFinished}
        />
    }
    helpMe = () => {
        if(this.state.help){
            this.setState({help:false});
        }else {
            this.setState({help:true});
        }
        
    }
    cancel = () => {
        this.setState({help:false});
        this.setState({finished:false});
        this.setState({isWaiting:false});
    }
    openProof = ()=> {return browserHistory.push(Tgcc.Routes.ProofEdit)}
    openDesigns = ()=> {return browserHistory.push(Tgcc.Routes.MajorAccountsDesignListView)}
    openApparel = ()=> {return browserHistory.push(Tgcc.Routes.MajorAccountsProductListView)}
    
    render () {
        var thankYou = this.state.finished ? this.getThankYou() : null;
        var waiting = this.state.isWaiting ? Tgcc.workingGif: <div style={btn} onClick={this.sendMessage}>Submit</div> 
        return (
            <div>
            <MajorAccountsHdr />
            <div style={topHr}>
                <div style={est}>Established 1994</div>
            </div>
            <div style={imgStyle} className="k12Banner"></div>
            <h1 style={generate} className="k12Cancel">Canceled Events? We can Help!</h1>
            <p style={p}>It may not have happened, but you still earned it. Let us help you remember it!</p>
            <div style={k12Group}>Group Apparel Orders Customized for your school</div>
            <div style={bullets} className="k12Bullets">
                <div>Easy Mobile Ordering</div>
                <div style={items}>Individual Payments</div>
                <div style={items}>Individually Shipped</div>
            </div>
            <p style={p1} className="offer">We offer individual payment and shipping options that make the ordering process super easy. And with our low 24 qty minimum, almost any group or event can participate.</p>
            <div style={process} className="k12Process">
                <div style={divs} className="k12Simple">
                    <h1 style={hdr1}>THE PROCESS IS SIMPlE!</h1>
                    <hr style={hr13}></hr>
                    <h2 style={h21}>WE DO THE WORK</h2>
                    <p style={creative}>Our creative team utilizes 25+ years of experience and nearly 10,000 designs to quickly produce a custom design that your entire group will love.</p>
                    <div>
                        <div>
                            <h2 style={h21}>YOU SPREAD THE WORD</h2>
                            <p style={creative}>We create a unique link to your very own ordering portal. You simply share the link with your entire group via email, text, and social media.</p>
                        </div>
                        <img src={Tgcc.ResolveUrl('~/images/phone1.png')} className="k12Phone"/>                    
                    </div>
                    <h2 style={h21} className="k12Print">WE PRINT AND SHIP THE SHIRTS</h2>
                    <p style={creative}>We take care of collecting individual orders and payments, quickly print your apparel, and indi- vidually ship to every member of your group. Bulk shipping to single locations also available upon request.</p>
                    <p style={creative}>Individual payments can be made with credit, debit, or Venmo.</p>
                    <img style={payment} src={Tgcc.ResolveUrl('~/images/payment.png')} />
                </div>
                <div style={divs1} className="k12Specials">
                    <h1 style={hdr1}>APPAREL SPECIALS</h1>
                    <hr style={hr13}></hr>
                    <img className="k12SpecialImg" src={Tgcc.ResolveUrl('~/images/hanesT.jpg')} width="475px"/>
                    <img className="k12SpecialImg" src={Tgcc.ResolveUrl('~/images/nextLevelT.jpg')} width="475px"/>
                    <img className="k12SpecialImg" src={Tgcc.ResolveUrl('~/images/comfortwashT.jpg')} width="475px"/>
                    <div>
                        <p style={creative1}>*Pricing shown based on 100 qty order and include a single color front print. Lower quantity orders and designs with multiple colors and print locations will be priced accordingly. Pricing does not include shipping charges. Additional $2 each for XXL and larger.</p>
                    </div>
                </div>
            </div>
            <div style={fund} className="k12FundOpt">
                <h1 style={hdr12}>Fundraising Options</h1>
                <hr style={hr13}></hr>
                <p style={fundTxt}>Want to add a fundraising component to your project? We can help with that too! Just specify how much you would like to up-charge each shirt. We send you or your charitable organization a check when the order is complete.</p>
            </div>
            <div style={k12Group1}>Group Apparel Orders Customized for your school</div>
            <div style={bullets1} className="k12Bullets">
                <div>Easy Mobile Ordering</div>
                <div style={items}>Individual Payments</div>
                <div style={items}>Individually Shipped</div>
            </div>
            <div style={btmDiv} className="k12BtmDiv">
                <img style={easyImg} src={Tgcc.ResolveUrl('~/images/easy.png')} className="k12EasyImg"/>
                <div style={btnDiv} className="k12BtnDiv">
                    <div style={btn} onClick={this.openProof}>Start a proof</div>
                    <div style={btn} onClick={this.openDesigns}>Explore our designs</div>
                    <div style={btn} onClick={this.openApparel}>Explore apparel</div>
                </div>
            </div>
            <h2 style={help}>Have Questions?</h2>
            <div style={contactdiv} className="maContactDiv">
                <div style={contactInfoDiv} className="k12InfoDiv">
                    <div style={callDiv}>
                        <h2 style={findout}>Contact Info</h2>
                        <div style={contactTxt}><i>Give me a call now. I'd love to help!</i></div>
                    </div>
                    <hr style={smallHr}></hr>
                    <div>
                        <h2 style={findout}>Andy Coyne</h2>
                        <div><a href="mailto:andy.coyne@grafcow.com" style={contactTxt}>andy.coyne@grafcow.com</a>
                        <div style={contactTxt}>864.380.3734</div>
                    </div>
                </div>
                </div>
            <div style={formDiv} className="k12ContactFm">
              <div id="feedback"></div> 
                    <h1 style={findout}>OR WE CAN CONTACT YOU</h1>
                    <div style={hdr}>Leave your info and we’ll call you with more details.</div>
                    <div style={errStyle}>{this.state.error}</div>
                    <div style={feedbackDiv} className='feedbackDiv'>
                        <div style={inputDiv}>
                            <label htmlFor="Name" className ="maContactLabel" style={label}>School Name:</label>
                            <input style={style} className="maContactInpt" type="text" name="name" onChange={this.handleNameChange}/>
                        </div>
                        <div style={inputDiv}>
                            <label htmlFor="Name" className ="maContactLabel" style={label}>Contact Name:</label>
                            <input style={style} type="text" className="maContactInpt" name="name" onChange={this.handleContactNameChange}/>
                        </div>
                        <div style={inputDiv}>
                            <label htmlFor="email" className ="maContactLabel" style={label}>Email:</label>
                            <input style={style} type="text" className="maContactInpt" name="email" onChange={this.handleEmailChange}/>
                        </div>
                        <div style={inputDiv}>
                            <label htmlFor="message" className ="maContactLabel" style={label}>Phone:</label>
                            <input style={style} type="text" className="maContactInpt" name="phone" onChange={this.handlePhoneChange}/> 
                        </div>
                        {waiting}
                    </div>
                      {thankYou}

            </div>
            </div>
            <MajorAccountsFooter state={this.props.state} />

            </div>
        )
    }
}

export var K12Landing = Radium(_K12Landing);